module.exports = __webpack_public_path__ + "media/images/swifticons/heart-5bd1d4d9404b2beb4a9b15a55aa3d583.svg";